import { Formulaire } from './formulaire';
import { MontantMarche } from './montant-marche';
import { TypeAvis } from './TypeAvis';
import { TypeMarche } from './TypeMarche';
import { TypeOrganisme } from './TypeOrganise';

export class CritereFormulaire {
    public id: Number;
    public typeOrganisme: TypeOrganisme;
    public typeMarche: TypeMarche;
    public montantMarche: MontantMarche;
    public typeAvis: TypeAvis;
    public formulaires: Array<Formulaire>;

    constructor() {
        this.typeAvis = new TypeAvis();
        this.typeOrganisme = new TypeOrganisme();
        this.montantMarche = new MontantMarche();
        this.typeMarche = new TypeMarche();

    }
}
